import { render, staticRenderFns } from "./Dividends.vue?vue&type=template&id=a133bcda&"
import script from "./Dividends.vue?vue&type=script&lang=ts&"
export * from "./Dividends.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports